import React from 'react';
import AppBar from '@material-ui/core/AppBar';
import Button from '@material-ui/core/Button';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import CardHeader from '@material-ui/core/CardHeader';
import CssBaseline from '@material-ui/core/CssBaseline';
import Grid from '@material-ui/core/Grid';
import StarIcon from '@material-ui/icons/StarBorder';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import Link from '@material-ui/core/Link';
import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import Box from '@material-ui/core/Box';
import Icon from '@material-ui/core/Icon';
import List from '@material-ui/core/List';
import ListItemText from '@material-ui/core/ListItemText';
import Paper from '@material-ui/core/Paper';
import CreditCardOffIcon from '@mui/icons-material/CreditCardOff';
import CodeOffIcon from '@mui/icons-material/CodeOff';
import CodeIcon from '@mui/icons-material/Code';
import SyncAltIcon from '@mui/icons-material/SyncAlt';
import JoinFullIcon from '@mui/icons-material/JoinFull';
import AllInclusiveIcon from '@mui/icons-material/AllInclusive';
import ShareIcon from '@mui/icons-material/Share';
import AccountTreeIcon from '@mui/icons-material/AccountTree';
import ReactGA from 'react-ga';
import Stack from '@mui/material/Stack';
import Alert from '@mui/material/Alert';
import Collapse from '@mui/material/Collapse';
import CloseIcon from '@mui/icons-material/Close';
import IconButton from '@material-ui/core/IconButton';

import { PopupButton, InlineWidget } from "react-calendly";
import Base13Icon from './../../Color just logo - no background.svg';

const useStyles = makeStyles((theme) => ({
  '@global': {
    ul: {
      margin: 0,
      padding: 0,
      listStyle: 'none',
      autoWidth: 'false',
    },
  },
  button: {
    margin: theme.spacing(1),
    justifyContent: 'left',
    justify: 'left',
  },
  image: {
    flex: 1,
    padding: 2,
    maxWidth: 120,
    // height: 100,
    resizeMode: 'contain'
  },
  paper: {
    maxWidth: 120,
    // height: 102,
    borderRadius:16,
    margin: 'auto',
    justifyContent: 'center',
  },
  link: {
    margin: theme.spacing(1, 1.5),
    textDecoration: 'none',
    color: 'white',
    underline: 'none',
    hover: {
    "&:hover": {
      color: '#cbd5e1'
      }
    }
  },
  image: {
    flex: 1,
    padding: 2,
    maxWidth: 120,
    // height: 100,
    resizeMode: 'contain'
  },
  signIn: {
    color: "black",
    backgroundColor:"white",
    borderColor:"white",
    textTransform: 'none',
    flex: 1,
    '&:hover': {
      backgroundColor:"#cecece",

    },
    },
  paper: {
    // maxWidth: 100,
    // height: 102,
    borderRadius:16,
    backgroundColor: '#0284c7',
    margin: 'auto',
    justifyContent: 'center',
    padding:50,
  },
  logoPadding: {
    flex: 1,
    padding: 2,
    maxWidth: 20,
    resizeMode: 'contain'
  },
  text: {
    margin: theme.spacing(1),
  },
  heroContent: {
    padding: theme.spacing(8, 0, 6),
    //backgroundColor: "#cccccc",
  },
  cardContent: {
    backgroundColor: 'white',
    color: '#0284c7'
  },
}));

  const eventTrack = (category, action, label) => {
    console.log("GA event:", category, ":", action, ":", label);
    ReactGA.event({
      category: category,
      action: action,
      label: label,
    })
  }

export default function SignUp() {
  const classes = useStyles();
  const [open, setOpen] = React.useState(true);

  return (
    <React.Fragment>
      <CssBaseline />
      	<Container maxWidth="lg" component="main" className={classes.heroContent}>
        <Grid container alignItems="flex-end" >
        <Grid xs={12} sm={3} md={3} lg={3} alignItems="flex-end"></Grid>
        <Grid xs={12} sm={6} md={6} lg={6} alignItems="flex-end">
        <Box sx={{ width: '100%'}} >
          <Collapse in={open}>
            <Alert color="info"
              action={
                <IconButton
                  aria-label="close"
                  color="inherit"
                  size="small"
                  onClick={() => {
                    setOpen(false);
                  }}
                >
                  <CloseIcon fontSize="inherit" />
                </IconButton>
              }
              sx={{ mb: 2 }}
            >
              <Box sx={{ fontWeight: 'bold', alignItems:"center",
            justifyContent:"center"}} display='inline' >Take advantage of our FREE Shopify ETL ingestion for a limited time.</Box>
            </Alert>
          </Collapse>
        </Box>
        </Grid>
        <Grid xs={12} sm={3} md={3} lg={3} alignItems="flex-end"></Grid>
        </Grid>
        <Box
        display="flex"
        alignItems="center"
        justifyContent="center"
        style={{padding:30}}
        >
          <img className={classes.image} src={Base13Icon}/>
        </Box>

          <Typography component="h1" style={{padding:20}} variant="h4" style={{ fontStyle: 'bolded', fontFamily: 'Arial' }} align="center" color="textPrimary" gutterBottom>
            Get started with FloSQL
          </Typography>

          <Box
            display="flex"
            alignItems="center"
            justifyContent="center"
            style={{padding:0}}
            >
          <Stack
          direction={{ xs: 'column', sm: 'row' }}
          display="flex"
          alignItems="center"
          justifyContent="center"
          >
            <SyncAltIcon style={{color:'#0284c7', width:20, height:20}} fontsize="small"/>
            <Typography variant="p1" style={{ fontFamily: 'Arial', padding:10 }} align="center" color="textSecondary" component="p">
             <Box sx={{ fontWeight: 'bold'}} display='inline' >ETL to Reverse-ETL</Box>
            </Typography>
          </Stack>
          </Box>
          <Box
            display="flex"
            alignItems="center"
            justifyContent="center"
            style={{padding:0}}
            >
          <Stack
            direction={{ xs: 'column', sm: 'row' }}
            display="flex"
            alignItems="center"
            justifyContent="center"
            >
            <AccountTreeIcon style={{color:'#0284c7', width:20, height:20}} fontsize="small"/>
            <Typography variant="p1" style={{ fontFamily: 'Arial', padding:10 }} align="center" color="textSecondary" component="p">
             <Box sx={{ fontWeight: 'bold'}} display='inline' >Leverage dbt and Apache Airflow</Box>
            </Typography>
            </Stack>
            </Box>
          <Box
            display="flex"
            alignItems="center"
            justifyContent="center"
            style={{padding:0}}
            >
          <Stack
            direction={{ xs: 'column', sm: 'row' }}
            display="flex"
            alignItems="center"
            justifyContent="center"
            >
            <JoinFullIcon style={{color:'#0284c7', width:20, height:20}} fontsize="small"/>
            <Typography variant="p1" style={{ fontFamily: 'Arial', padding:10 }} align="center" color="textSecondary" component="p">
             <Box sx={{ fontWeight: 'bold'}} display='inline' >Work with SQL</Box>
            </Typography>
          </Stack>
          </Box>
          <Box
            display="flex"
            alignItems="center"
            justifyContent="center"
            style={{padding:0}}
            >
          <Stack
            direction={{ xs: 'column', sm: 'row' }}
            display="flex"
            alignItems="center"
            justifyContent="center"
            >
            <CreditCardOffIcon style={{color:'#0284c7', width:20, height:20}} fontsize="small"/>
            <Typography variant="p1" style={{ fontFamily: 'Arial', padding:10 }} align="center" color="textSecondary" component="p">
             <Box sx={{ fontWeight: 'bold'}} display='inline' >No credit card required</Box>
            </Typography>
          </Stack>
          </Box>

          <Box
                display="block"
                alignItems="center"
                justifyContent="center"
                style={{padding:20}}
              >
              </Box>


        <Grid container alignItems="flex-end" spacing={2}>
              <Grid xs={1} sm={3} md={4} lg={4} >
                <Box
                display="block"
                alignItems="center"
                justifyContent="center"
                style={{padding:0}}
              >
              </Box>
              </Grid>
              <Grid xs={10} sm={6} md={4} lg={4} >
              <Box
                display="block"
                alignItems="center"
                justifyContent="center"
                style={{padding:20}}


              >
                {/*<Card elevation={2} >
                <CardContent >*/}
                <Paper className={classes.paper}>
                  <Typography component="h5" style={{padding:100}} variant="h6" style={{ fontStyle: 'bolded', fontFamily: 'Arial', color:'white' }} align="center" color="white" gutterBottom>
                    Start with our <Box sx={{ fontWeight: 'bold'}} display='inline' >free</Box> version
                  </Typography>

                {/*</CardContent >*/}

                  <Box
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                    style={{paddingBottom:10}}
                    >
                        <Box m="auto" className={classes.button} alignItems="center">
                          <Button className={classes.signIn} size="large" href='https://app.flosql.com/new_account' variant="contained" startIcon={<Icon className="fab fa-github" style={{ color: 'black'}} onClick={eventTrack.bind(this, "Sign Up Screen", "Github Sign Up Button", "Button")} />} >Sign up with Github</Button>
                        </Box>
                      </Box>

                      </Paper>
              </Box>
              <Typography component="h5" style={{padding:100}} variant="p2" style={{ fontFamily: 'Arial', color:'grey' }} align="center" color="textSecondary" gutterBottom>
                By creating an account, you agree to the <Link href='/TermsOfService' color="textSecondary"><Box sx={{ textDecoration: 'underline'}} display='inline' >Terms of Service</Box></Link> and <Link href='/PrivacyPolicy' color="textSecondary"><Box sx={{ textDecoration: 'underline'}} display='inline' >Privacy Policy</Box></Link>.
              </Typography>
              </Grid>
              <Grid xs={1} sm={3} md={4} lg={4} >
                <Box
                display="block"
                alignItems="center"
                justifyContent="center"
                style={{padding:0}}
              >
              </Box>
              </Grid>

          </Grid>

      	</Container>
    </React.Fragment>
  );
}